<!-- <ng-container *ngIf="lookupdata.length > 0"> -->
<section class="mx-3">
  <ng-container>
    <div class="d-flex justify-content-between align-items-center">
      <div class="page_header">
        <h4 class="m-0 page_header_title">Acadamic Calendar List</h4>
      </div>
      <!-- <div *ngIf="actiondata.create">
              <button
                mat-raised-button
                color="primary"
                (click)="openAddAcademicsDialog()"
                class="px-5 add_button"
              >Add</button>
            </div> -->
    </div>
    <div class="position-relative">
      @if (isLoadingResults || isRateLimitReached) {
      <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner class="mat_spinner"></mat-spinner>
        } @if (isRateLimitReached) {
        <div class="rate-limit-reached">
          GitHub's API rate limit has been reached. It will be reset in one
          minute.
        </div>
        }
      </div>
      }
      <ng-container *ngIf="actiondata.list_view">
        <div class="mt-2 table-container">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!-- <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox
                      (change)="$event ? toggleAllRows() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      [aria-label]="checkboxLabel()"
                    >
                    </mat-checkbox>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox
                      (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      [aria-label]="checkboxLabel(row)"
                    >
                    </mat-checkbox>
                  </td>
                </ng-container>
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef>Sl.no</th>
                  <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                </ng-container> -->
            <ng-container matColumnDef="start_year">
              <th mat-header-cell *matHeaderCellDef>Start Date</th>
              <td mat-cell *matCellDef="let element">{{ element.start_date }}</td>
            </ng-container>
            <ng-container matColumnDef="end_year">
              <th mat-header-cell *matHeaderCellDef>End Date</th>
              <td mat-cell *matCellDef="let element">
                {{ element.end_date}}
              </td>
            </ng-container>
            <ng-container matColumnDef="course_name">
              <th mat-header-cell *matHeaderCellDef>Course name</th>
              <td mat-cell *matCellDef="let element">
                <div class="status-container">
                  {{ element.course_name }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="academic_regulation_code">
              <th mat-header-cell *matHeaderCellDef>Academic Regulation</th>
              <td mat-cell *matCellDef="let element">
                <div class="status-container">
                  {{ element.academic_regulation_code }} ({{element.regulation_start_year}} -
                  {{element.regulation_end_year}})
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let row">
                <div class="d-flex align-items-center">
                  <button mat-raised-button class="action_button" (click)="showsemesterdetails(row)">
                    View
                  </button>
                  <mat-icon class="m-0" [matMenuTriggerFor]="createmenu" aria-hidden="false" aria-label="more option"
                    fontIcon="more_vert"></mat-icon>
                  <mat-menu #createmenu="matMenu">
                    <small [disabled]="this.selection.selected.length == 0" mat-menu-item
                      (click)="openAddAcademicsDialog(row)">Edit</small>
                  </mat-menu>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">No data</td>
            </tr>
          </table>
        </div>
        <div class="mt-2" *ngIf="total_count > 5">
          <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <!--
        </ng-container>
        <ng-container *ngIf="lookupdata.length <= 0">
        <p>No data Found</p>
        </ng-container>
      
        <ng-container *ngIf="showaddflag">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
              <h4 class="m-0">Add Courses</h4>
            </div>
            <div>
              <button mat-raised-button color="primary" (click)="showadd()" class="px-5">Back</button>
            </div>
          </div>
          <div class="container">
            <form (ngSubmit)="onSubmit()" [formGroup]="form">
                <div class="row">
                    <div *ngFor="let question of questions" class="col-sm-6">
                        <app-question [question]="question" [form]="form"></app-question>
                    </div>
                </div>
                <div class="form-row">
                    <button mat-flat-button color="primary" class="px-5" type="submit" [disabled]="!form.valid">
                        Save
                    </button>
                </div>
            </form>
          
            
              <div *ngIf="payLoad" class="form-row">
                <strong>Saved the following values</strong><br>{{payLoad}}
              </div>
            </div>
          </ng-container>-->
</section>